import React from "react";
import stylesLess from "./index.module.less";
import stylesCommon from "../../../common.module.scss";
import XtInput from "../../xt/input";
import XtSvg from "../../xt/svg";
import SvgError from "../../../svg/error";

export default React.forwardRef(function FormItemInput(props, ref) {
  const {
    isErr,
    value,
    maxLength = 128,
    autoComplete = "new-password",
    disabled,
    onInput,
    onFocus,
    onBlur,
    suffix,
    noCloseBtn,
    ...rest
  } = props;

  const [state_isFocus, setState_isFocus] = React.useState(false);

  const refInput = React.useRef();

  const handleInput = (val) => {
    onInput && onInput(val ? val.trim() : val);
  };
  const handleInputFocus = (e) => {
    // console.log("handleInputFocus");
    setState_isFocus(true);
    onFocus && onFocus(e);
  };
  const handleInputBlur = (e) => {
    // console.log("handleInputBlur");
    setState_isFocus(false);
    onBlur && onBlur(e);
  };

  const handleClear = () => {
    onInput && onInput("");
    refInput.current.focus();
  };

  const classList = [stylesLess.main];
  isErr && classList.push("err");
  state_isFocus && classList.push("atv");

  React.useImperativeHandle(ref, () => ({
    inputEl: refInput.current,
  }));

  return (
    <div className={`${classList.join(" ")}`}>
      <XtInput
        ref={refInput}
        value={value}
        autoComplete={autoComplete}
        maxLength={maxLength}
        disabled={disabled}
        onInput={handleInput}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        {...rest}
      />
      {(value || value === 0) && !noCloseBtn && (
        <button
          className={`${stylesCommon.btnTxt} ico`}
          disabled={disabled}
          onClick={handleClear}
        >
          <SvgError />
        </button>
      )}
      {suffix}
    </div>
  );
});
